import { Component, Input } from 'angular-ts-decorators';

import template from './coveo-analytics-wrapper.html';
import { getWebStoreApiClient } from '@gn-audio/core/auth/web-store-api/client';
import { getEmailFromAccount } from '@gn-audio/core/auth/uip/utilities';

@Component({
    selector: 'coveoAnalyticsWrapper',
    template,
})
export class CoveoAnalyticsWrapperComponent {
    @Input() public accessToken: string;
    @Input() public organizationId: string;
    @Input() public coveoUserAnalyticsUrl: string;

    public readonly authorizedUserEmail?: string;

    constructor() {
        this.authorizedUserEmail = this.getAuthorizedUserEmail();
    }

    private getAuthorizedUserEmail(): string {
        const account = getWebStoreApiClient().account;
        if (!account) {
          return '';
        }

        return getEmailFromAccount(account);
    }
}
